<template>
    <div class="process-icon">
        <div v-if="type === 'warning'" class="process-icon-warning">
            <div class="process-icon-warning-body"></div>
            <div class="process-icon-warning-dot"></div>
        </div>

        <div v-if="type === 'success'" class="process-icon-success">
            <div class="process-icon-success-tip"></div>
            <div class="process-icon-success-long"></div>
            <div class="process-icon-success-placeholder"></div>
            <div class="process-icon-success-fix"></div>
        </div>

        <div v-if="type === 'error'" class="process-icon-error">
            <div class="process-icon-error-x">
                <div class="process-icon-error-left"></div>
                <div class="process-icon-error-right"></div>
            </div>
            <div class="process-icon-error-placeholder"></div>
            <div class="process-icon-error-fix"></div>
        </div>
    </div>
</template>

<style>
.process-icon-success{
    z-index: 0 !important;
}
</style>

<script>
	export default {
		props: ["type"],
	};
</script>